import util from '../util'

let controller = 'EnvioMovManual'
export default Object.assign({}, util.GetCrud(controller, ['post']))
